export default __webpack_public_path__ + "static/media/icon-brain.def4c005.png";